module.exports = __webpack_public_path__ + "static/media/miwa.bee84de6.jpeg";